function getFormatTitle(title: string) {
  return title.replace(/\\/g, '')
}

export default getFormatTitle
